module.exports = __webpack_public_path__ + "static/media/expense-green.00b3f65a.svg";